export default __webpack_public_path__ + "static/media/Mobile-login-bro.0a5df47b.svg";